import { AssetIcon } from '@/components/icons';
import { fileTypeExcelIcon } from '@/assets/icons';
import { truncateAttachmentFilename } from '@/utils/truncateAttachmentFilename';

interface CsvAttachmentChipProps {
  fileName: string;
}

/** Read-only Excel chip shown above user message bubbles in bulk import flow. */
export function CsvAttachmentChip({ fileName }: CsvAttachmentChipProps) {
  const displayName = truncateAttachmentFilename(fileName);

  return (
    <div
      className="bulk-import__attachment-chip"
      role="group"
      aria-label={`Attached file ${fileName}`}
    >
      <AssetIcon
        src={fileTypeExcelIcon}
        className="bulk-import__attachment-chip-icon"
        width={22}
        height={22}
      />
      <span className="bulk-import__attachment-chip-name" title={fileName}>
        {displayName}
      </span>
    </div>
  );
}
